export const tableClass = {
  tdClass: "px-3 py-2 border border-top",
  thClass: "px-3 py-2 text-left",
};
